// using {@see https://github.com/jackocnr/intl-tel-input} for phone number input
import intlTelInput from 'intl-tel-input';
import {addExportWarningListeners} from "./../../admin/scripts/utils/form.js";

/**
 * Takes an input element and initializes the intlTelInput plugin.
 * @param input
 */
export function initTelInput(input) {
    let name = input.getAttribute('name')
    input.setAttribute('name', `${name}_iti`)
    intlTelInput(input, {
        initialCountry: "auto",
        strictMode: true,
        geoIpLookup: callback => {
            fetch("https://ipapi.co/json")
                .then(res => res.json())
                .then(data => callback(data.country_code))
                .catch(() => callback("ca"));
        },
        hiddenInput: (telInputName) => ({
            phone: name
        }),
        loadUtils: () => import("intl-tel-input/utils"),
    });
}

(function($, window) {
    var Selector = {
        APPLICATION_TYPE: '.js-application-type:input',
        APPLICATION_CONTACT_GROUP: '.js-grp-application-contact',
        APPLICATION_EMAIL_GROUP:'.js-grp-application-email',
        EXTERNAL_URL_GROUP: '.js-grp-external-url',

        ARTICLE_CATEGORY: '.js-article-category',
        ARTICLE_LOCATION_GROUP: '.js-grp-article-location',

        CANDIDATE_MIGRATION_STATUS: '.js-candidate-migration-status',
        CANDIDATE_PARALLEL_MIGRATION_GROUP: '.js-grp-candidate-parallel-migration',
        CANDIDATE_CURRENT_ADDRESS_GROUP: '.form-group-paj\\\/model\\\/details\\\/current',

        EXPLORATORY_REGION: '.js-exploratory-region:input',
        EXPLORATORY_MRCS: '.js-exploratory-mrcs:input',

        EXPLORATORY_COLLABORATOR: '.js-exploratory-collaborator:input',
        EXPLORATORY_COLLABORATOR_CONTACT: '.js-exploratory-collaborator-contact:input',

        EDUCATION_AREA: '.js-education-area:input',
        EDUCATION_AREA_SUBDIVISION: '.js-education-area-subdivision',

        USER_COUNTRY: 'select.js-user-country',
        USER_PROVINCE: 'select.js-user-province',

        USER_SELECTIZE: '.js-user-selectize',

        ADMIN_USER_ROLE: '.js-admin-user-role:input',
        ADMIN_USER_REGION: '.js-admin-user-grp-region',
        ADMIN_USER_MRC: '.js-admin-user-grp-mrc',

        EMPLOYER_LARGE_URBAN_CENTER: '.js-employer-large-urban-center',
        EMPLOYER_MRC: '.js-employer-mrc',

        CANDIDATE_BIRTH_DATE: '.js-candidate-birth-date',
        CANDIDATE_AGE: '.js-candidate-age',
    }

    // Initial scraping of all tel inputs on the page to initialize them.
    const inputs = document.querySelectorAll("input[type=\"tel\"]");
    inputs.forEach(initTelInput);

    /**
     * Trigger the application contact form group on selected application type.
     *
     * @listens change
     *
     * @return {void}
     */
    var onChangeJobOfferApplicationContact = function () {
        const selected = $(this);
        const groups = [
            $(Selector.APPLICATION_CONTACT_GROUP),
            $(Selector.APPLICATION_EMAIL_GROUP),
            $(Selector.EXTERNAL_URL_GROUP),
        ];

        const $exploratoryCollaboratorContact = $(Selector.APPLICATION_CONTACT_GROUP).find('select'+Selector.EXPLORATORY_COLLABORATOR_CONTACT)
        const exploratoryCollaboratorContact = $exploratoryCollaboratorContact[0]

        const existingInterval = $exploratoryCollaboratorContact.data('waitForInit2');
        if (existingInterval) {
            clearInterval(existingInterval);
            $exploratoryCollaboratorContact.removeData('waitForInit2');
        }

        if (exploratoryCollaboratorContact.selectize !== undefined) {
            exploratoryCollaboratorContact.selectize.disable()
            exploratoryCollaboratorContact.selectize.lock()
        } else {
            let attempts = 0;
            const maxAttempts = 50; // 5 seconds max (50 * 100ms)

            // Polling is not ideal but the selectize implementation in charcoal admin doesn't fire any ready event for us to bind to.
            const waitForInit2 = setInterval(() => {
                attempts++;
                if (exploratoryCollaboratorContact.selectize !== undefined) {
                    clearInterval(waitForInit2);
                    $exploratoryCollaboratorContact.removeData('waitForInit2');
                    onChangeJobOfferApplicationContact.bind(this)();
                } else if (attempts >= maxAttempts) {
                    clearInterval(waitForInit2);
                    $exploratoryCollaboratorContact.removeData('waitForInit2');
                    console.warn('Selectize initialization timeout for input:', $exploratoryCollaboratorContact);
                }
            }, 100);

            $exploratoryCollaboratorContact.data('waitForInit2', waitForInit2);
            return;
        }

        groups.forEach(function (group) {
            group.addClass('hidden').find('input,select').prop('disabled', true);
        });

        switch(selected.val()) {
            case 'contact':
                $(Selector.APPLICATION_CONTACT_GROUP).removeClass('hidden');
                $('.bootstrap-select, .btn.dropdown-toggle', Selector.APPLICATION_CONTACT_GROUP).removeClass('disabled');
                $('input,select', Selector.APPLICATION_CONTACT_GROUP).prop('disabled', false);
                exploratoryCollaboratorContact.selectize.enable()
                exploratoryCollaboratorContact.selectize.unlock()
                break;

            case 'email':
                $(Selector.APPLICATION_EMAIL_GROUP).removeClass('hidden');
                $('input', Selector.APPLICATION_EMAIL_GROUP).prop('disabled', false);
                break;

            case 'external':
                $(Selector.EXTERNAL_URL_GROUP).removeClass('hidden');
                $('input', Selector.EXTERNAL_URL_GROUP).prop('disabled', false);
                break;

            default:
                break;

        }
    };

    /**
     * Trigger the article location group on article category selected.
     *
     * @listens change
     *
     * @return {void}
     */
    var onChangeArticleCategory = function () {
        var selected = $(this);

        if (parseInt(selected.val()) === 1) {
            $(Selector.ARTICLE_LOCATION_GROUP).show();
        } else {
            $(Selector.ARTICLE_LOCATION_GROUP).hide();
        }
    };

    var onChangeRelatedSelect = function ($selected, $input) {
        // The subdivision field should not be required when used in the advanced search.
        const isAdvancedSearch = $input.closest('.c-filters').length > 0;

        $input.attr('data-hide-disabled', true);

        if (typeof $input.data('required') == 'undefined') {
            $input.attr('data-required', $input.prop('required'));
        }

        if (!isAdvancedSearch && $input.data('required')) $input.prop('required', true);

        let $label = $input.closest('fieldset').find('label');
        if (!$selected.attr('multiple') && !$label.find('.text-danger').length) {
            $label.append(' <span class="text-danger"></span>');
        }

        if (!$selected.val()) {
            $input.selectpicker('val', null);
            $input.selectpicker('hide');

            if (!isAdvancedSearch && $input.data('required')) $input.prop('required', false);

            $label.find('.text-danger').empty();
            return;
        }

        var selectedOptions = $selected.children('option:selected');

        $input.find('optgroup').prop('disabled', true);

        // retreive 2nd selected values
        var selectedInputValues = [];
        $input.find('option:selected').each(function(key, selectedInput){
            selectedInputValues.push($(selectedInput).val());
        });

        $input.selectpicker('hide');

        var selectableInputValues = [];
        selectedOptions.each(function(key, selectedOption) {
            var selectedLabel = $(selectedOption).text();

            var $group = $input.find(`optgroup[label="${selectedLabel}"]`);
            if ($group.length !== 0) {
                // retreive 2nd seletable values
                $group.find('option').each(function(key, selectableValue) {
                    selectableInputValues.push($(selectableValue).val());
                });

                $group.prop('disabled', false);
                $input.selectpicker('refresh');
                $input.selectpicker('show');
            }
        });

        // remove element that was previously selected and cannot be from 1st select options
        var elementToRemoveFromInput = subtractarrays(selectedInputValues, selectableInputValues);
        $(elementToRemoveFromInput).each(function(key, optionId){
            $input.find(`option[value="${optionId}"]`).prop('selected', false)
        });

        if (!selectableInputValues.length) {
            if (!isAdvancedSearch && $input.data('required')) $input.prop('required', false);
            $label.find('.text-danger').empty();
        } else {
            if (!isAdvancedSearch && $input.data('required')) $input.prop('required', true);
            $label.find('.text-danger').html('*');
        }
    };

    /**
     * Trigger the MRCS listing on country selected
     *
     * @listens change
     *
     * @return {void}
     */
    var onChangeUserCountry = function () {
        var selected = $(this);
        var selectedVal = selected.val();

        if (!['CA', 'US'].includes(selectedVal)) {
            $(Selector.USER_PROVINCE).val('');
            $(Selector.USER_PROVINCE).prop('disabled', true);
            $(Selector.USER_PROVINCE).selectpicker('refresh');
            return;
        }

        var availableOptions = $(Selector.USER_PROVINCE).find(`option[data-group=${selectedVal}]`).map((key, option) => $(option).val()).get()
        if (!availableOptions.includes($(Selector.USER_PROVINCE).val())) {
            $(Selector.USER_PROVINCE).val('');
        }

        $(Selector.USER_PROVINCE).prop('disabled', false);
        $(Selector.USER_PROVINCE).find(`option`).hide();
        $(Selector.USER_PROVINCE).find(`option[data-group=${selectedVal}]`).show();
        $(Selector.USER_PROVINCE).selectpicker('refresh');
        $(Selector.USER_PROVINCE).selectpicker('show');
    };

    /**
     * Trigger the Region/Mrc listing on role selected
     *
     * @listens change
     *
     * @return {void}
     */
    var onChangeAdminUserRole = function() {
        var selected = $(this);
        var selectedVal = selected.val();

        $(Selector.ADMIN_USER_REGION).hide();
        $(Selector.ADMIN_USER_MRC).hide();

        if (selectedVal === 'regionAgent') {
            $(Selector.ADMIN_USER_REGION).show();
            $(Selector.ADMIN_USER_MRC).hide();
        } else if (selectedVal === 'mrcAgent') {
            $(Selector.ADMIN_USER_REGION).hide();
            $(Selector.ADMIN_USER_MRC).show();
        }

    }

    /**
     * Trigger the MRCS listing on region selected Region
     *
     * @listens change
     *
     * @return {void}
     */
    window.onChangeExploratoryRegion = function () {
        return onChangeRelatedSelect($(this), $(Selector.EXPLORATORY_MRCS));
    };

    /**
     * Trigger the collaborator contacts listing on collaborator selected
     *
     * @listens change
     *
     * @return {void}
     */
    window.onChangeExploratoryCollaborator = function () {
        const $inputs = $(Selector.EXPLORATORY_COLLABORATOR_CONTACT)

        $inputs.each(fetchCollaboratorContacts)
    };

    var fetchCollaboratorContacts = function(index, input) {
        const $input = $(input);
        // Clear any existing polling interval
        const existingInterval = $input.data('waitForInit');
        if (existingInterval) {
            clearInterval(existingInterval);
            $input.removeData('waitForInit');
        }

        if (!input.selectize) {
            let attempts = 0;
            const maxAttempts = 50; // 5 seconds max (50 * 100ms)

            // Polling is not ideal but the selectize implementation in charcoal admin doesn't fire any ready event for us to bind to.
            const waitForInit = setInterval(() => {
                attempts++;

                if (input.selectize !== undefined) {
                    clearInterval(waitForInit);
                    $input.removeData('waitForInit');
                    fetchCollaboratorContacts(index, input);
                } else if (attempts >= maxAttempts) {
                    clearInterval(waitForInit);
                    $input.removeData('waitForInit');
                    console.warn('Selectize initialization timeout for input:', $input);
                }
            }, 100);

            // Store interval reference
            $input.data('waitForInit', waitForInit);
            return;
        }

        input.selectize.loadFilteredOptions([
            {
                property: 'collaborator',
                value: $(Selector.EXPLORATORY_COLLABORATOR).val(),
            }
        ], function(options) {
            if (input.selectize.isLocked) {
                return;
            }

            (options !== null && options.length > 0) ? input.selectize.enable() : input.selectize.disable()
        })
    }

    /**
     * Trigger an EducationAreaSubdivision listing refresh on EducationArea selection.
     *
     * @listens change
     *
     * @return {void}
     */
    var onChangeEducationArea = function () {
        return onChangeRelatedSelect($(this), $(Selector.EDUCATION_AREA_SUBDIVISION));
    };

    var onOpenEducationArea = function (dropdown) {
        // Highlight old areas + subdivisions
        console.log('searching for deprecated areas...');

        dropdown.querySelectorAll('.dropdown-item').forEach(function(option) {
            if (option.querySelector('.text')?.textContent?.endsWith('(à reclasser)')) {
                console.log('Found:' + option.querySelector('.text')?.textContent);
                option.classList.add('deprecated');
            }
        });

        return;
    };

    /** SUBTRACT ARRAYS **/
    function subtractarrays(array1, array2){
        var difference = [];
        for( var i = 0; i < array1.length; i++ ) {
            if( $.inArray( array1[i], array2 ) == -1 ) {
                        difference.push(array1[i]);
            }
        }

        return difference;
    }

    /**
     * Trigger the user details info URL (candidate / employer) on user changed (selectize)
     * Also triggered in quick-form
     *
     * @listens change
     *
     * @return {void}
     */
    window.onChangeUserSelectize = function() {
        var selected = $(this);

        var selectedVal = selected.val();
        var userDetailsInfos = $(this).closest('.row').find('.user-details');
        if (selectedVal === '') {
            userDetailsInfos.hide();
        } else {
            var userObjType = userDetailsInfos.attr('obj-type');
            userDetailsInfos.find('a').attr('href', `/admin/object/edit?main_menu=&obj_type=${userObjType}&obj_id=${selectedVal}`);
            userDetailsInfos.show();
        }
    };

    /**
     * Show/hide MRC field if LargeUrbanCenter is selected
     *
     * @listens change
     *
     * @return {void}
     */
    var onChangeEmployerLargeUrbanCenter = function() {
        var checkbox = $('input', this);
        var mrcField = $(Selector.EMPLOYER_MRC).closest('.form-group');

        mrcField.hide();

        if (checkbox.prop('checked') != true) {
            mrcField.show();
        }
    }

    var onChangeCandidateBirthData = function(e) {
        const birthDate = $(this).val();
        const ageInput = $(Selector.CANDIDATE_AGE);
        const age = moment().diff(moment(birthDate), 'years');

        if (age) {
            ageInput.val(age);
        } else {
            ageInput.val(' - ');
        }
    }

    var onChangeCandidateCity = function(e) {
        const nearest_form_group = $(Selector.CANDIDATE_CURRENT_ADDRESS_GROUP)
        const current_city = $('.form-property-city input', Selector.CANDIDATE_CURRENT_ADDRESS_GROUP).val();

        if (!current_city.length) {
            $(nearest_form_group).addClass('highlight');
        } else {
            $(nearest_form_group).removeClass('highlight');
        }
    }

    $(document).on('change', Selector.APPLICATION_TYPE, onChangeJobOfferApplicationContact);
    $(Selector.APPLICATION_TYPE).trigger('change');

    $(document).on('change', Selector.ARTICLE_CATEGORY, onChangeArticleCategory);
    $(Selector.ARTICLE_CATEGORY).trigger('change');

    $(document).on('change', Selector.EXPLORATORY_REGION, window.onChangeExploratoryRegion);
    $(Selector.EXPLORATORY_REGION).trigger('change');

    $(document).on('change', Selector.EXPLORATORY_COLLABORATOR, window.onChangeExploratoryCollaborator);
    $(Selector.EXPLORATORY_COLLABORATOR).trigger('change');

    $(document).on('change', Selector.EDUCATION_AREA, onChangeEducationArea);
    $(Selector.EDUCATION_AREA).trigger('change');

    $(document).on('change', Selector.USER_COUNTRY, onChangeUserCountry);
    $(Selector.USER_COUNTRY).trigger('change');

    $(document).on('change', Selector.USER_SELECTIZE, window.onChangeUserSelectize);
    $(Selector.USER_SELECTIZE).trigger('change');

    $(document).on('change', Selector.ADMIN_USER_ROLE, onChangeAdminUserRole);
    $(Selector.ADMIN_USER_ROLE).trigger('change');

    $(document).on('change', Selector.EMPLOYER_LARGE_URBAN_CENTER, onChangeEmployerLargeUrbanCenter);
    $(Selector.EMPLOYER_LARGE_URBAN_CENTER).trigger('change');

    $(Selector.CANDIDATE_BIRTH_DATE).on('input.datetimepicker', onChangeCandidateBirthData);

    $('.form-property-city', Selector.CANDIDATE_CURRENT_ADDRESS_GROUP).on('change', onChangeCandidateCity);
    $('.form-property-city', Selector.CANDIDATE_CURRENT_ADDRESS_GROUP).trigger('change');

    // Attach observer for dropdown open (class 'open' or 'show')
    $(Selector.EDUCATION_AREA + ',' + Selector.EDUCATION_AREA_SUBDIVISION).each(function() {
        const wrapper = $(this).closest('.bootstrap-select')[0];
        if (!wrapper) return;

        const classObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (
                    mutation.attributeName === 'class' &&
                    wrapper.classList.contains('show')
                ) {
                    const dropdown = wrapper.querySelector('.dropdown-menu');
                    console.log('Selectize dropdown opened for:', $(dropdown));
                    onOpenEducationArea(dropdown);
                }
            });
        });
        classObserver.observe(wrapper, { attributes: true });
    });


    // Add an observer to trigger the change event on dynamically loaded forms (modals)
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                $(mutation.addedNodes).each(function() {
                    // Check if any child nodes match the EDUCATION_AREA selector
                    $(this).find(Selector.EDUCATION_AREA).each(function() {
                        $(this).triggerHandler('change');
                    });

                    // Look for selectize wrapper
                    if (
                        this.classList &&
                        this.classList.contains('bootstrap-select') &&
                        (
                            this.classList.contains('js-education-area') ||
                            this.classList.contains('js-education-area-subdivision')
                        )
                    ) {
                        // Find the related select/input if needed
                        const dropdown = this.querySelector('.dropdown-menu');
                        console.log('Added dropdown: ', $(dropdown));

                        // Attach observer for dropdown open (class 'open' or 'show')
                        const wrapper = this;
                        const classObserver = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                if (
                                    mutation.attributeName === 'class' &&
                                    wrapper.classList.contains('show')
                                ) {
                                    console.log('Selectize dropdown opened for:', $(dropdown));
                                    onOpenEducationArea(dropdown);
                                }
                            });
                        });
                        classObserver.observe(wrapper, { attributes: true });
                    }
                });
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    addExportWarningListeners();

})(jQuery, window);
